"use strict";

var _html = require("linkifyjs/html");

var _html2 = _interopRequireDefault(_html);

var _sortablejs = require("sortablejs");

var _sortablejs2 = _interopRequireDefault(_sortablejs);

var _VueSweetalert = require("./plugins/VueSweetalert2");

var _VueSweetalert2 = _interopRequireDefault(_VueSweetalert);

var _Toastr = require("./plugins/Toastr");

var _Toastr2 = _interopRequireDefault(_Toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window._ = require("lodash");

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  window.$ = window.jQuery = require("jquery");

  require("bootstrap-sass");
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.axios.defaults.headers.common["X-CSRF-TOKEN"] = window.globals.csrfToken;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

String.prototype.ucfirst = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

window.Vue = require("vue");

Vue.directive("sortable", {
  inserted: function inserted(el, binding) {
    _sortablejs2.default.create(el, binding.value || {});
  }
});

Vue.directive("click-outside", {
  bind: function bind(el, binding, vnode) {
    el.event = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.event);
  },
  unbind: function unbind(el) {
    document.body.removeEventListener("click", el.event);
  }
});

Vue.filter("capitalize", function (value) {
  if (!value) {
    return "";
  }

  value = value.toString();

  return value.ucfirst();
});

Vue.filter("highlight", function (words, query) {
  if (!query) {
    return words;
  }

  var regExp = new RegExp(query, "ig");
  return words.toString().replace(regExp, function (matchedTxt) {
    return "<span class='highlight'>" + matchedTxt + "</span>";
  });
});

Vue.filter("youtube-linkify", function (text) {
  var urlRegex = /(https?:\/\/[^\s\<]+)/g;

  return (text || '').replace(urlRegex, function (url) {
    if (url.includes("youtube") || url.includes("youtu.be")) {
      //Get id
      url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
      var id = url[2] !== undefined ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];

      return "<iframe frameborder=\"0\" allowfullscreen=\"true\" src=\"https://www.youtube.com/embed/" + id + "\"></iframe>";
    }

    return url;
  });
});

Vue.filter("linkify", function (text) {
  return (0, _html2.default)(text, {
    defaultProtocol: "https"
  });
});

Vue.use(_VueSweetalert2.default);
Vue.use(_Toastr2.default);

require("./utilities/functions.js");
require("./utilities/event.js");
require("./utilities/request.js");
require("core-js");


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/bootstrap.js
// module id = WRGp
// module chunks = 0 1